import { PlusIcon } from '@heroicons/react/24/outline';
import { useState } from 'react';

import { withSandbox } from 'utils/withSandbox';

import { useGetCollectionFundingInstructions } from 'api';

import { useOrganisationId } from 'hooks/context';
import { useFeatureAccessControl } from 'hooks/useFeatureAccessControl';

import { PrimaryButton } from '@atoms/buttons/PrimaryButton';

import { SANDBOX_ADD_FUNDS_BUTTON_TEST_ID } from './constants';
import { SandboxAddFundsModal } from './SandboxAddFundsModal';
import { sandboxT } from './translations';

type Props = {
  accountNumber: string;
};

const SandboxAddFundsWrapperInner = ({ accountNumber }: Props) => {
  const [open, setOpen] = useState(false);

  const organisationId = useOrganisationId<number>();

  const { isSandboxFundingEnabled } = useFeatureAccessControl();
  const { data: { data: fundingInstructions } = {}, isLoading } =
    useGetCollectionFundingInstructions(organisationId, {
      query: { enabled: Boolean(organisationId) }
    });

  const accountFundingInstructionsList = fundingInstructions?.[accountNumber];

  if (
    isLoading ||
    !accountFundingInstructionsList?.length ||
    !isSandboxFundingEnabled
  )
    return null;

  return (
    <>
      <PrimaryButton
        icon={<PlusIcon className="size-5 stroke-current" />}
        onClick={() => setOpen(true)}
        data-testid={SANDBOX_ADD_FUNDS_BUTTON_TEST_ID}
      >
        {sandboxT.common.actions.addFunds}
      </PrimaryButton>

      <SandboxAddFundsModal
        open={open}
        setOpen={setOpen}
        fundingInstructions={accountFundingInstructionsList}
      />
    </>
  );
};

export const SandboxAddFundsWrapper = withSandbox(SandboxAddFundsWrapperInner);
